export default __webpack_public_path__ + "static/img8-a6e6453375df4e8b89a2fd17635f4f97.png";